import firebase from '../../../config/firebase';

const database = firebase.database();


export function getHome(callback) {
  database.ref('settings').on('value', function(snapshot) {
    var home = {};
    if (snapshot.exists()) {
      home = snapshot.val();
    }
    callback(true, home, null);
  });
}

export function editHome (data, callback) {
  database.ref('settings').update(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  });
}
